const BASE_URL =
	process.env.NODE_ENV === 'production'
		? 'https://www.careconvene.com'
		: 'https://meta-phor.com';

module.exports = {
	// paths
	BASE_URL,
	API_URL: BASE_URL + '/api',
	CHAT_URL: BASE_URL,

	// cookie ids
	CCPT: 'ccpt',
	CCPID: 'ccpid',
	CCPUSERNAME: 'ccpusername',
	CCSTARTPAGE: 'cc-start-page',

	// miscellaneous
	DASHBOARD_PAGE_SIZE: 10,
	TRACKING_BOARD_REFRESH: 60000, // 1 minute
	TRACKING_BOARD_REFRESH_BACKGROUND: 600000, // 10 minutes
	PATIENT_NOTIFICATION_REFRESH: 300000, // 5 minutes
	PHONE_MASK: [
		'(',
		/[1-9]/,
		/\d/,
		/\d/,
		')',
		' ',
		/\d/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
	],

	// evisit status
	EVISIT_STATUS: {
		IN_REVIEW: 'in_review',
		READY_FOR_PROVIDER: 'ready_for_provider',
		IMH_IMCOMPLETE: 'imh_incomplete',
		IN_PROGRESS: 'in_progress',
		CANCELLED: 'cancelled_before_capture',
		SCHEDULED: 'scheduled',
		CREATED: 'created',
		CANCELLED_APPOINTMENT: 'cancelled_appointment',
		SCHEDULED_PENDING: 'scheduled_confirmed',
		REOPENED: 'reopened',
		EXPIRED: 'expired',
	},
};
